import { useShiftNavigator } from "@dexteel/mesf-core";
import { get } from "react-hook-form";
import { useLogbookContext } from "../context/logbookContext";
import { getEntries } from "../repository/LogbookRepository";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchEntries = ({ setIsLoading, setError }: Props) => {
	const {
		state: {
			FilterParameters: { SearchText, AssetId },
		},
		actions: { setEntriesList, setLoadingTable },
	} = useLogbookContext();
	const { shiftInfo } = useShiftNavigator();
	return async () => {
		if (shiftInfo?.CurrentShiftId) {
			setIsLoading(true);
			setLoadingTable(true);
			const res = await getEntries(
				null,
				SearchText,
				AssetId,
				shiftInfo?.CurrentShiftId || null,
			);
			if (res.ok) {
				const rowsSource = get(res, "data", []);
				const dataTable = rowsSource.tables[0];

				setEntriesList(dataTable.rows);
			} else setError(res.message);
			setIsLoading(false);
			setLoadingTable(false);
		}
	};
};
